import { Button } from '@consigli/facade';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { DateRange, getDateForRange } from '@/util/date';

export interface MeetingFilterValues {
  dateRange?: DateRange;
  startDate?: string;
  endDate?: string;
}

interface MeetingFiltersProps {
  filters: MeetingFilterValues;
  onFiltersChange: (filters: MeetingFilterValues) => void;
}

export const MeetingFilters: FC<MeetingFiltersProps> = ({ filters, onFiltersChange }) => {
  const { t } = useTranslation();

  const handleDateRangeClick = useCallback(
    (range: DateRange) => {
      if (range === DateRange.All) {
        onFiltersChange({
          dateRange: DateRange.All,
          startDate: undefined,
          endDate: undefined,
        });
        return;
      }

      const dates = getDateForRange(range);

      onFiltersChange({
        dateRange: range,
        startDate: dates.startDate,
        endDate: dates.endDate,
      });
    },
    [onFiltersChange],
  );

  const currentDateRange = filters.dateRange || DateRange.All;

  return (
    <div className="flex items-center gap-2">
      <div className="flex flex-wrap gap-2">
        <Button
          {...(currentDateRange === DateRange.All ? { primary: true } : { secondary: true })}
          rounded
          onClick={() => handleDateRangeClick(DateRange.All)}
        >
          {t('meeting-secretary.filters.all-time')}
        </Button>
        <Button
          {...(currentDateRange === DateRange.Today ? { primary: true } : { secondary: true })}
          rounded
          onClick={() => handleDateRangeClick(DateRange.Today)}
        >
          {t('meeting-secretary.filters.today')}
        </Button>
        <Button
          {...(currentDateRange === DateRange.ThisWeek ? { primary: true } : { secondary: true })}
          rounded
          onClick={() => handleDateRangeClick(DateRange.ThisWeek)}
        >
          {t('meeting-secretary.filters.this-week')}
        </Button>
        <Button
          {...(currentDateRange === DateRange.LastWeek ? { primary: true } : { secondary: true })}
          rounded
          onClick={() => handleDateRangeClick(DateRange.LastWeek)}
        >
          {t('meeting-secretary.filters.last-week')}
        </Button>
        <Button
          {...(currentDateRange === DateRange.ThisMonth ? { primary: true } : { secondary: true })}
          rounded
          onClick={() => handleDateRangeClick(DateRange.ThisMonth)}
        >
          {t('meeting-secretary.filters.this-month')}
        </Button>
      </div>
    </div>
  );
};
